const actions = {
  SET_STATE: 'registration/SET_STATE',
  REFRESH_ERRORS: 'registration/REFRESH_ERRORS',
  ALL: 'registration/ALL',
  FETCH_ALL: 'registration/FETCH_ALL',
  FETCH_MEMBERS_ALL: 'registration/FETCH_MEMBERS_ALL',
  FETCH_CONTACTS_ALL: 'registration/FETCH_CONTACTS_ALL',
  FETCH_PARENTS_ALL: 'registration/FETCH_PARENTS_ALL',
  EXPORT: 'registration/EXPORT',
  EXPORT_MEMBERS: 'registration/EXPORT_MEMBERS',
  EXPORT_CONTACTS: 'registration/EXPORT_CONTACTS',
  EXPORT_PARENTS: 'registration/EXPORT_PARENTS',
  PRINT: 'registration/PRINT',
  REFRESH_PRINT: 'registration/REFRESH_PRINT',
  PRINT_MEMBERS: 'registration/PRINT_MEMBERS',
  PRINT_CONTACTS: 'registration/PRINT_CONTACTS',
  PRINT_PARENTS: 'registration/PRINT_PARENTS',
  REFRESH_MEMBERS_PRINT: 'registration/REFRESH_MEMBERS_PRINT',
  REFRESH_CONTACTS_PRINT: 'registration/REFRESH_CONTACTS_PRINT',
  REFRESH_PARENTS_PRINT: 'registration/REFRESH_PARENTS_PRINT',
  EMAILS: 'registration/EMAILS',
  REFRESH_EMAILS: 'registration/REFRESH_EMAILS',
  DETAILS: 'registration/DETAILS',
  MOVE: 'registration/MOVE',
  ADD: 'registration/ADD',
  EDIT: 'registration/EDIT',
  REMOVE: 'registration/REMOVE',
  CHANGE_IS_DEACTIVATED: 'registration/CHANGE_IS_DEACTIVATED'
};

export default actions
